import { forwardRef } from 'react';
import { twJoin } from 'tailwind-merge';

import { createBaseInput } from '@/core/tamagoshiTailwind/components/Input/createBaseInput';
import {
  type BaseInputSettings,
  type ExtractBaseInputPropsType,
} from '@/core/tamagoshiTailwind/components/Input/utils/BaseInputTypes';

type BaseInputTextProps = {
  /** Type of the input */
  type?: 'text' | 'number';
};

const settings = {
  as: 'input',
  detectEmpty: false,
  rounded: 'card',
  helperText: true,
  statuses: ['default', 'error', 'success', 'disabled'],
  requiredLabel: true,
} satisfies BaseInputSettings<'input'>;

const BaseInput = createBaseInput(settings);

type InputTextProps = ExtractBaseInputPropsType<
  typeof settings,
  BaseInputTextProps
>;

/**
 * A text or numeric input component.
 *
 * See the related [Figma][figma] for more details.
 *
 * [figma]: https://www.figma.com/design/KAiRlBccr6bFYmKby9wQrR?node-id=15902-18017
 */
export const InputText = forwardRef<HTMLInputElement, InputTextProps>(
  (props, ref) => (
    <BaseInput
      {...props}
      className={twJoin(props.type === 'number' && 'remove-spin-buttons')}
      pattern={props.type === 'number' ? '\\d*' : undefined}
      ref={ref}
    />
  ),
);

InputText.displayName = 'InputText';
